import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/components/Landing";
import AdminDashboard from "@/components/AdminDashboard";
import FounderVision from "@/components/FounderVision";
import BrandPage from "@/components/BrandPage";
import StickyQuote from "@/components/StickyQuote";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" theme="light" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/brands/:key" element={<BrandPage />} />
          <Route path="/founder" element={<FounderVision />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <StickyQuote />
      </BrowserRouter>
    </div>
  );
}

export default App;
